
export default {
  data() {
    return {
      activeTab: this.$t("text.personalDetails"),
      tabData: [
        {
          name: this.$t("text.personalDetails"),
          logout: false,
          component: "ui-profile-personal-details",
        },
        {
          name: this.$t("text.orderHistory"),
          logout: false,
          component: "ui-profile-order-history",
        },
        {
          name: this.$t("text.passwordSettings"),
          logout: false,
          component: "ui-profile-password-settings",
        },
        {
          name: this.$t("text.logout"),
          logout: true,
          component: "div",
        },
      ],
    };
  },

  methods: {
    setActiveTab(value) {
      this.activeTab = value.name;
    },
  },
};
